(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rdtn-desktop-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('.rdtn-desktop-nav details[open]').forEach(details => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rdtn-desktop-nav details[open]').forEach(details => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
